import React from 'react'
import {
  MfaLearnMoreLink,
  MfaNoticeIcon,
  MfaNoticeLogin,
  MfaNoticeSignup,
} from './styled'

const MFA_LEARN_MORE_URL =
  'https://support.goguardian.com/s/article/Pear-Assessment-Multi-Factor-Authentication-MFA'

const MfaNotice = ({ isLoginPage }) => {
  const Notice = isLoginPage ? MfaNoticeLogin : MfaNoticeSignup

  return (
    <Notice>
      <span>
        <MfaNoticeIcon color="currentColor" /> We&apos;ll soon require
        multi-factor authentication for password logins. Please consider using
        SSO.{' '}
        <MfaLearnMoreLink
          href={MFA_LEARN_MORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn More
        </MfaLearnMoreLink>
      </span>
    </Notice>
  )
}

export default MfaNotice
